export const userDocuments = {
    isPending: false,
    error: null,
    data: [],
    files: []
};
